<template>
  <b-card
    class="playlist-item playlist-item-dy mb-3"
    no-body
    img-left
    @click="clickPlaylistItem(index)"
  >
    <!-- <b-row no-gutters> -->
    <!-- <b-col cols="3"> -->
    <b-card-img
      :src="media.cover_image.full_path"
      alt="Image"
      class="rounded-0"
    ></b-card-img>
    <span class="playlist-item-duration">{{
      getTimeDuration(media.time_duration)
    }}</span>
    <!-- </b-col>
      <b-col cols="9"> -->
    <b-card-body class="p-2">
      <h5 class="playlist-item-title">{{ media.title }}</h5>
      <h6 class="playlist-item-subtitle">{{ media.created_by }}</h6>
    </b-card-body>
    <!-- </b-col>
    </b-row> -->
  </b-card>
</template>
<script>
export default {
  name: "PlaylistItem",
  props: ["media", "index"],
  data() {
    return {};
  },
  methods: {
    getTimeDuration(duration_str) {
      console.log("get time", duration_str);
      //   let durations_arr = duration_str.split(/[-:_]/)
      if (duration_str.indexOf("hours") == -1) {
        duration_str = "00 hours " + duration_str;
      }
      console.log(duration_str);
      //   console.log(duration_str.replace(" hours ","$").replace(" minutes ","$").replace(" seconds","$").split("$").slice(0, -1))
      let splitters = [" hours ", " minutes ", " seconds"]; // or ",:;".split("");
      // let start= "a,b;c:d";
      let durations_arr = splitters.reduce(
        (old, c) => old.map((v) => v.split(c)).flat(),
        [duration_str]
      );
      console.log(durations_arr);
      console.log(durations_arr.slice(0, -1));

      let time_str = "";
      for (let i = 0; i < durations_arr.length; i++) {
        if (i < durations_arr.length - 2) {
          time_str += durations_arr[i] + ":";
        } else {
          time_str += durations_arr[i];
        }
      }
      console.log(time_str);
      return time_str;
    },
    clickPlaylistItem(index){
        console.log(this.$parent)
        this.$parent.$parent.$parent.clickPlaylistItem(index)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/media/PlaylistItem.vue